import { MapPin, Trophy, Award, Flag, Calendar } from 'lucide-react';
import { defineSchema, CANONICAL_TRACKS, CANONICAL_CHAMPIONSHIPS, CANONICAL_CATEGORIES, CANONICAL_SESSION_TYPES } from '@shared/search';

export const driverHistorySchema = defineSchema({
  id: 'driver-history',
  title: 'filter.schema.driverHistory.title',
  subtitle: 'filter.schema.driverHistory.subtitle',
  defaultField: 'track',
  fields: {
    track: {
      key: 'track',
      label: 'filter.field.track',
      type: 'enum',
      icon: MapPin,
      allowMultiple: true,
      description: 'filter.desc.track',
      options: CANONICAL_TRACKS,
      example: 'track:Wohlen',
    },
    championship: {
      key: 'championship',
      label: 'filter.field.championship',
      type: 'enum',
      icon: Trophy,
      allowMultiple: true,
      description: 'filter.desc.championship',
      options: CANONICAL_CHAMPIONSHIPS,
      example: 'championship:RMC',
    },
    category: {
      key: 'category',
      label: 'filter.field.category',
      type: 'enum',
      icon: Award,
      allowMultiple: true,
      description: 'filter.desc.category',
      options: CANONICAL_CATEGORIES,
      example: 'category:Max',
    },
    type: {
      key: 'type',
      label: 'filter.field.sessionType',
      type: 'enum',
      icon: Flag,
      allowMultiple: true,
      description: 'filter.desc.sessionType',
      options: CANONICAL_SESSION_TYPES,
      example: 'type:race',
    },
    position: {
      key: 'position',
      label: 'filter.field.finishPosition',
      type: 'range',
      icon: Trophy,
      min: 1,
      max: 50,
      description: 'filter.desc.position',
      example: 'position:<=3',
      presets: [
        { label: 'filter.preset.posWinner', value: '1', operator: '=' },
        { label: 'filter.preset.posPodium', value: '3', operator: '<=' },
        { label: 'filter.preset.posTop5', value: '5', operator: '<=' },
        { label: 'filter.preset.posTop10', value: '10', operator: '<=' },
      ],
    },
    season: {
      key: 'season',
      label: 'filter.field.season',
      type: 'number',
      icon: Calendar,
      description: 'filter.desc.season',
      example: 'season:2026',
      presets: [
        { label: '2026', value: '2026', operator: '=' },
        { label: '2025', value: '2025', operator: '=' },
        { label: '2024', value: '2024', operator: '=' },
      ],
    },
    from: {
      key: 'from',
      label: 'filter.field.date',
      type: 'dateRange',
      icon: Calendar,
      description: 'filter.desc.date',
      example: 'from:-1y',
      datePresets: [
        { label: 'filter.preset.today', value: 'today' },
        { label: 'filter.preset.last30d', value: '-30d' },
        { label: 'filter.preset.last90d', value: '-90d' },
        { label: 'filter.preset.last1y', value: '-1y' },
      ],
    },
  },
  examples: [
    { q: 'track:Wohlen position:<=3', desc: 'filter.example.podiumWohlen' },
    { q: 'category:"DD2" season:2026', desc: 'filter.example.dd2Races2026' },
    { q: 'position:=1 from:-1y', desc: 'filter.example.victoriesLast1y' },
  ],
});

